/**
 * Whether a placed order still needs an online payment (partial deposit or
 * full amount) via PayZone, vs. pay-in-full-on-site / bank transfer.
 *
 * Mirrors the price math in screens/Booking/thankyou.js's calcPrices — kept
 * here as a single small boolean check so navigation call sites (
 * ConfirmAuthSheet.js, checkout.js) can decide /thankyou vs /payment right
 * after placing the order, without duplicating the full price-breakdown
 * calculation thankyou.js itself needs.
 *
 * @param {object} order - the order_response payload (has `prices`,
 *   `percentage_paid`, and optionally `coupon_value`/`customer_discount`).
 * @returns {boolean}
 */
export default function orderNeedsPayment(order) {
  if (!order) return false;
  let totalPrice = 0;
  (order.prices || []).forEach((price) => {
    totalPrice += parseInt(price.price) * parseInt(price.qt ?? price.quantities);
  });
  const percentageSettings = 100 - order.percentage_paid;
  const discountPct = parseInt(order.coupon_value) ? parseInt(order.coupon_value) : parseInt(order.customer_discount);
  const total = totalPrice - (totalPrice / 100) * (discountPct || 0);
  const forPay = total - (total / 100) * percentageSettings;
  return Math.round(forPay) > 0;
}
